module.exports = __webpack_public_path__ + "static/media/device_pc.9afa7ef6.svg";